import despesasRotas from "./despesas/DespesasRotas"
import PagamentosRotas from "./pagamento/PagamentosRotas"

export default {
    path: 'demandantes',
    name: 'DespesasGerais_Demandantes',
    component: {
        render(c) {
            return c('router-view')
        }
    }, 
    children: [despesasRotas, PagamentosRotas]
}